export const initializeElmo = () => {
  // hack to retrieve elmo function which was previously a script tag
  require('@cfc/elmo');
}
